import { Variants } from 'framer-motion'

export const titleAnimation = (delay: number): Variants => ({
  initial: {
    opacity: 0,
    y: 30,
  },
  opacityIn: {
    opacity: 1,
    transition: {
      duration: 1,
      ease: 'linear',
      delay,
    },
  },
  transformIn: {
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeInOut',
      delay,
    },
  },
})

export const paragraphAnimation = (delay: number): Variants => ({
  initial: {
    opacity: 0,
    y: 75,
  },
  opacityIn: {
    opacity: 1,
    transition: {
      duration: 1,
      ease: 'linear',
      delay,
    },
  },
  transformIn: {
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeInOut',
      delay,
    },
  },
})
